export default __webpack_public_path__ + "static/media/rubik-v12-latin-600.a2c44918.woff2";